import axios from 'axios';
export const get = (triggerEvent) => {
    return axios.get('/cart.js').then((res) => {
        return processResponse(res.data);
    });
};
const cartUpdated = (items, count) => {
    window.dispatchEvent(new CustomEvent('hg-cart-updated', {
        detail: {
            items,
            count,
        },
    }));
};
export const add = (items) => {
    if (items.length === 0) {
        return;
    }
    return axios
        .post('/cart/add.js', {
        items,
    })
        .then((res) => {
        get();
        // Shopify only returns and array with { "items": []} when using add, the rest of the endpoints return the full Cart object
        const lineItems = res.data.items;
        return lineItems;
    });
};
export const update = (updates) => {
    if (Object.keys(updates).length === 0) {
        return;
    }
    return axios
        .post(window.Shopify.routes.root + 'cart/update.js', {
        updates: updates,
    })
        .then((res) => {
        return processResponse(res.data);
    });
};
export const change = (item) => {
    return axios.post('/cart/change.js', item).then((res) => {
        return processResponse(res.data);
    });
};
export const deleteItems = (deletes) => {
    if (Object.keys(deletes).length === 0) {
        return;
    }
    const updates = {};
    deletes.forEach((id) => {
        updates[id] = 0;
    });
    return update(updates);
};
export const empty = () => {
    return axios.post('/cart/clear.js').then((res) => {
        return processResponse(res.data);
    });
};
const processResponse = (cartData) => {
    const lineItems = cartData.items;
    const count = cartData.item_count;
    cartUpdated(lineItems, count);
    return cartData;
};
export default {
    get,
    add,
    update,
    change,
    delete: deleteItems,
    empty,
};
